// extracted by mini-css-extract-plugin
export var addToCart = "style-mod--add-to-cart--d39f7";
export var additionalText = "style-mod--additional-text--de72d";
export var advancedProductGroup = "style-mod--advanced-product-group--9301a";
export var badge = "style-mod--badge--6c78e";
export var benefits = "style-mod--benefits--a4361";
export var blockedVariantStyle = "style-mod--blocked-variant-style--6be2d";
export var borderLine = "style-mod--border-line--3000b";
export var box = "style-mod--box--17c68";
export var cartBtn = "style-mod--cart-btn--9be65";
export var cartButton = "style-mod--cart-button--908bd";
export var clipStar = "style-mod--clip-star--cbec9";
export var collectionSliderMob = "style-mod--collection-slider-mob--0ff0d";
export var compAtPrice = "style-mod--comp-at-price--91426";
export var deliveryOptions = "style-mod--delivery-options--cc4f7";
export var desktopSwitcher = "style-mod--desktop-switcher--e6cef";
export var desktopView = "style-mod--desktop-view--037b8";
export var disabledBtn = "style-mod--disabled-btn--7ab17";
export var doContent = "style-mod--do-content--772a3";
export var frContent = "style-mod--fr-content--0ba57";
export var freeReturns = "style-mod--free-returns--8e583";
export var freeShippingText = "style-mod--free-shipping-text--05b78";
export var helpIcon = "style-mod--help-icon--6470c";
export var infoDescription = "style-mod--info-description--498a1";
export var infoLinkableText = "style-mod--info-linkable-text--df792";
export var infoSection = "style-mod--info-section--0f3be";
export var infoTitle = "style-mod--info-title--7fd92";
export var mobPrice = "style-mod--mob-price--250ad";
export var mobileAccordion = "style-mod--mobile-accordion--54362";
export var mobileCookingHub = "style-mod--mobile-cooking-hub--bbe10";
export var mobileView = "style-mod--mobile-view--10040";
export var multipleCategories = "style-mod--multiple-categories--9a9d5";
export var openedMenu = "style-mod--opened-menu--04b28";
export var parentGroup = "style-mod--parent-group--c9c5c";
export var paymentIcons = "style-mod--payment-icons--8e2d0";
export var paymentMethodContainer = "style-mod--payment-method-container--763d0";
export var pdpPriceBox = "style-mod--pdp-price-box--a0e19";
export var priceBox = "style-mod--price-box--95cde";
export var pricesAndBadge = "style-mod--prices-and-badge--5292e";
export var prodPrice = "style-mod--prod-price--be0a8";
export var productDescription = "style-mod--product-description--c68fb";
export var productLinkVarB = "style-mod--product-link-var-b--c1948";
export var productPrice = "style-mod--product-price--bfbb5";
export var productPriceCompare = "style-mod--product-price-compare--cc195";
export var productSubtitle = "style-mod--product-subtitle--43bd1";
export var productTitle = "style-mod--product-title--70d1f";
export var productTitlePrice = "style-mod--product-title-price--f0185";
export var productTitlePriceRow = "style-mod--product-title-price-row--8401a";
export var productTitleSmall = "style-mod--product-title-small--808a6";
export var questionMark = "style-mod--question-mark--684c0";
export var ratingText = "style-mod--rating-text--338ce";
export var returnInfo = "style-mod--return-info--8d27d";
export var returnText = "style-mod--return-text--a4836";
export var reviewsBelow = "style-mod--reviews-below--f89c2";
export var reviewsPdp = "style-mod--reviews-pdp--6db41";
export var scalapay = "style-mod--scalapay--6fa1b";
export var scalapayIcons = "style-mod--scalapay-icons--2103e";
export var selected = "style-mod--selected--1dcf5";
export var selectedCat = "style-mod--selected-cat--07eff";
export var shippingEta = "style-mod--shipping-eta--d3741";
export var singleProduct = "style-mod--single-product--11b8c";
export var specificBadgeProd = "style-mod--specific-badge-prod--f3775";
export var specificBadgeVariant = "style-mod--specific-badge-variant--2556b";
export var stickyPrice = "style-mod--sticky-price--fc797";
export var stickyPriceBox = "style-mod--sticky-price-box--b13e8";
export var titleAndReviews = "style-mod--title-and-reviews--ff8a3";
export var titlePriceBox = "style-mod--title-price-box--9e75a";
export var tooltipInfo = "style-mod--tooltip-info--8d4b4";
export var twoVariantsRow = "style-mod--two-variants-row--e170a";
export var variantSnippet = "style-mod--variant-snippet--53b45";
export var variantsInOneLine = "style-mod--variants-in-one-line--53f20";
export var voucherBadge = "style-mod--voucher-badge--08864";
export var yStars = "style-mod--y-stars--9936e";